import { Pagination, Stack } from '@mui/material';
import styled from 'styled-components';

export const PaginationContainer = styled(Stack)`
  && {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.25rem;
    height: 4.5rem;
    justify-self: flex-end;
  }
`;

export const StyledPagination = styled(Pagination)`
  && {
    & .MuiPaginationItem-root {
      padding: 0 0.625rem;
      border-radius: ${({ theme }) => theme.shape.buttonRadius.extraSmall};

      &:hover {
        background-color: ${({ theme }) => theme.palette.background.default};
      }

      &.Mui-selected {
        color: ${({ theme }) => theme.palette.primary.main};
        font-weight: bold;

        &:not(:hover) {
          background-color: transparent;
        }
      }

      &:not(.Mui-selected) {
        color: ${({ theme }) => theme.palette.secondary.main};
      }
    }

    & .MuiPaginationItem-ellipsis {
      color: ${({ theme }) => theme.palette.primary.main};
      height: ${({ theme }) => theme.shape.buttonHeight.extraSmall};
      border-radius: ${({ theme }) => theme.shape.buttonRadius.extraSmall};
      line-height: ${({ theme }) => theme.shape.buttonHeight.extraSmall};
    }

    &.Mui-disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;
